import axios from "./axiosInstance";

export async function downloadVideoContent(video_content_id: string, body: any) {
    const response = await axios.post(process.env.REACT_APP_BASE_URL + `/videoContent/downloadClip/${video_content_id}`, body);
    return response.data;
}